import { observable } from 'mobx'

import Store from '../shared/store'
import { apiStore, FileUploadMiddleware } from '../shared/api'
import { apiClient } from '../shared/api-impl'

import { museum as config } from '../config'

import Museum from './model'

@apiStore(apiClient, [
  new FileUploadMiddleware({
    attrKeys: [
      { key: 'links', fieldName: 'pdf' },
      { key: 'images', fieldName: 'image' }
    ],
    // type: 'image'
  })
])
class MuseumStore extends Store {

  @observable loading = false

  @observable collection = []

  @observable filterCollection = []

  @observable current = null

  constructor(opts = {}) {

    super(opts)

    this.Model = Museum

    this.initAPIStore({
      ...opts,
      api: config.api,
    })

  }

  loadPublic(id, opts = {}, data = null) {
    opts.action = 'loadPublic'
    return this.api.load(id, opts, data)
  }

  load(...args) {
    return this.api.load(...args)
  }

  save(...args) {
    return this.api.save(...args)
  }

  destroy(...args) {
    return this.api.destroy(...args)
  }

  where(filter, opts = {}) {

    if (!Array.isArray(filter)) {
      filter = Object.keys(filter)
        .filter((key) => filter[key] !== -1 && filter[key] !== '-1')
        .map((key) => {
          const filterSpec = {
            id: key,
            type: key,
            value: filter[key],
            operator: 'and'
          }

          if (Array.isArray(filter[key])) {
            filterSpec.comparator = key === 'grade' ? 'between' : 'in'
          }

          return filterSpec
        })
    }

    return super.where(filter, opts)

  }

}

export default MuseumStore



// WEBPACK FOOTER //
// ./src/museum/store.js